import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const providerInfoBadgeStyle = css`
  display: inline-flex;
  align-items: center;
  gap: ${theme.spacing(0.5)};
  background-color: ${theme.colors.primary5};
  padding: ${theme.spacing(0.5, 1)};
  border-radius: ${theme.borderRadius.small};
`;

export const providerInfoBadgeButtonStyle = [
  providerInfoBadgeStyle,
  css`
    > span {
      display: inline-flex;
      align-items: center;
      gap: ${theme.spacing(0.5)};
    }
  `,
];
